import React, { useEffect, useState } from "react";
import AddPlanModele from "./AddPlanModele";
import { Divider, Card, MenuItem } from "@mui/material";
import { ADMIN_SERVER_BASE_URL, apiClient } from "../util/apiClient";
import { useDispatch, useSelector } from "react-redux";
import {
  IModeleRapport,
  IPlanItem,
  setModelesRapport,
  // setHideListeModele,
  updateModeleRapport,
  updateModelesRapportApresEnvoieEnLigne,
  setFilteredModelesRapport,
  IModeleRapportState,
} from "../store/modeleRapportSlice";
import AddModele from "./AddModele";
import AfficheContenuPlan from "./AfficheContenuPlan";
import { Grid, Button } from "@mui/material";
import { IReduxState } from "../store";

//radio
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import AddModeleAPartirDUnModeleExistant from "./AddModeleAPartirDUnModeleExistant";
import ListeModeleRapport from "./ListeModeleRapport";

//checkbox
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import { errorNotify, successNotify } from "../util/functions";

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import SearchBar from "../components/GestionFonctionnalite/SearchBar";
import { setFailledPlansRapport } from "../store/persisteSlice";
import { findIndex } from "lodash";
// import { setPlanRapport } from "../store/persistSlice";
import { TextField } from "@mui/material";


const initialModele: IModeleRapport = {
  idModeleRapport: "",
  libelleModeleRapport: "",
  planModeleRapport: [],
  status: 0,
  revision: 0,
  modificationMiseEnLigne: 0,
  canGeneret: 0
};

export interface ITypesRapport {
  idTypeRapport: number | null;
  libelleTypeRapport: string;
}

const typesRapport: ITypesRapport[] = [
  { idTypeRapport: 1, libelleTypeRapport: "Word" },
  { idTypeRapport: 2, libelleTypeRapport: "Excel" }
];

const Rapport = () => {
  //redux
  const dispatch = useDispatch();
  const { modelesRapport, planItemToEdit } = useSelector(
    (state: IReduxState) => state.modeleRapport
  );

  const { creer } = useSelector((state: IReduxState) => state.application);
  const { failledPlansRapport } = useSelector((state: IReduxState) => state.persiste );
    
 
  //Hooks
  const [planRapport, setPlanRapport] = useState<IPlanItem[]>([]);
  const [objetModele, setObjetModele] = useState<IModeleRapport>(initialModele);
  const [renderModeleEditable, setRenderModeleEditable] = useState(false);
  // const [addUserLoading, setAddUserLoading] = useState(false);
  const [loading, setLoading] = React.useState(false);
  // const [disableButton, setDisableButton] = React.useState(false);
  const [disableSaveButton, setDisableSaveButton] = React.useState(true);

  const [currentModele, setCurrentModele] = useState<any>({});
  const [mode, setMode] = useState("add");
  // const [planItem, setPlanItem] = useState<any>(
  //   mode === "edit" ? planItemToEdit : undefined
  // );
  const [planItem, setPlanItem] = useState<IPlanItem | undefined | any>( mode === "edit" ? planItemToEdit : undefined);
  const [libelleModeleRapport, setLibelleModeleRapport] = useState<string>("");
  const [libelleModeleRapportToEdit, setLibelleModeleRapportToEdit] = useState<string>("");
  const [value, setValue] = React.useState("nouveau");
  const [modelesSelected, setModelesSelected] = React.useState<string[]>([]);
  const [typeRapport, setTypeRapport] = useState<ITypesRapport>({ idTypeRapport: null, libelleTypeRapport: "" })
  const [search, setSearch] = React.useState("");
  const theme = useTheme();
  const endesssousDeLg = useMediaQuery(theme.breakpoints.down("lg"));

  const filterFonction = () => {
    if (search.length === 0) {
      dispatch(setFilteredModelesRapport([...modelesRapport]));
    } else {
      const result: any = modelesRapport.filter(
        (item: IModeleRapport, index: number) => {
          const value: any = `${item.libelleModeleRapport} ${item.idModeleRapport}`;
          return value.toLowerCase().includes(search.toLowerCase());
        }
      );
      dispatch(setFilteredModelesRapport(result));
    }
  };

  const handleInputChange = (e: any) => {
    const { value, name } = e.target;
    setTypeRapport({ ...typeRapport, [name]: value });
  };


  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value);
    setPlanRapport([]);
    setCurrentModele({});
  };

  // const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   dispatch(setHideListeModele(event.target.checked));
  // };

  //Obtenir la liste des modeles déjà enregistrés
  const getModelesRapportData = async () => {
    try {
      const res: any = await apiClient.get(
        ADMIN_SERVER_BASE_URL,
        "/tablesystem/listemodelerapport"
      );
      if (res.status === 1) {
        const parsedData = res.data.map((item: any) => {
          return {
            ...item,
            planModeleRapport: JSON.parse(item.planModeleRapport),
          };
        });
        dispatch(setModelesRapport(parsedData));
        dispatch(setFilteredModelesRapport(parsedData));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: getModelesRapportData ~ error", error);
    }
  };

  const updateFailedInsertedPlanRapport = async () => {
    const index = failledPlansRapport.findIndex(
      (item) => item.index === planItem?.index
    );
    if (index >= 0) {
      const newPlanRapport: IPlanItem[] = [
        ...failledPlansRapport.slice(0, index),
        planItem,
        ...failledPlansRapport.slice(index + 1),
      ];
      dispatch(setFailledPlansRapport(newPlanRapport));
    } else {
      dispatch(setFailledPlansRapport([...failledPlansRapport, planItem]));
    }
  };

  // enregistrer le plan obtenu dans la bd
  const handleSavePlan = async () => {
    try {
      setLoading(true);

      const modele = modelesRapport.find(
        (item) => item.idModeleRapport === currentModele?.idModele
      );

      // const apiPayload = {
      //   ...modele,
      //   planModeleRapport:  planRapport,
      // };

      const apiPayload: any = {
        ...modele,
        planModeleRapport: planRapport,
      };

      const res: any = await apiClient.post(
        ADMIN_SERVER_BASE_URL,
        "/tablesystem/modifiermodelerapport",
        apiPayload
      );
      if (res.status === 1) {
        // const parsedData = {
        //   ...res.data,
        //   planModeleRapport: JSON.parse(res.data.planModeleRapport),
        // };
        dispatch(updateModeleRapport(res.data));
        setLoading(false);
        successNotify("Plan de rapport enregistré avec succès.");
        setDisableSaveButton(true);
        dispatch(setFailledPlansRapport([]));
      } else {
        console.log("status !==1");
        setLoading(false);
        errorNotify("Erreur d'enregistrement du plan de rapport.");
        updateFailedInsertedPlanRapport();
      }
    } catch (error) {
      setLoading(false);
      console.log("🚀 ~ file: handleSave ~ error", error);
      errorNotify("Erreur d'enregistrement du plan de rapport.");
      updateFailedInsertedPlanRapport();
    }
  };

  useEffect(() => {
    getModelesRapportData();
  }, []);

  return (
    <Grid
      container
      spacing={3}
      style={{
        height: "80vh",
        overflow: "auto",
        paddingRight: 10,
      }}
    >
      <Grid item md={12} xs={12} sm={12}>
        <SearchBar
          filterFonction={filterFonction}
          search={search}
          setSearch={setSearch}
        />
      </Grid>

      {creer ? (
        <>
          <Grid item md={7} xs={12} sm={12}>
            <fieldset>
              <legend>Création d'un modèle</legend>
              <Grid
                container
                spacing={2}
              >
                <Grid item md={6} xs={12} sm={12}>
                  <FormControl>
                    <RadioGroup
                      row
                      name="modeleACreer"
                      value={value}
                      onChange={handleChange}
                    >
                      <FormControlLabel
                        value="nouveau"
                        control={<Radio />}
                        label="Nouveau modèle"
                      />

                      <FormControlLabel
                        value="apartirDUnModeleExistant"
                        control={<Radio />}
                        label="A partir d'un modèle existant"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Grid item md={6} xs={12} sm={12}>
                  <TextField
                    fullWidth
                    size="small"
                    select
                    label="Type de rapport"
                    name="idTypeRapport"
                    value={typeRapport.idTypeRapport}
                    onChange={(e) => handleInputChange(e)}
                  >
                    {typesRapport.map((item: any, index: number) => (
                      <MenuItem key={index} value={item.idTypeRapport}>
                        {item.libelleTypeRapport}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

              </Grid>


              {value === "nouveau" && (
                <AddModele
                  renderModeleEditable={renderModeleEditable}
                  objetModele={objetModele}
                  libelleModeleRapport={libelleModeleRapport}
                  setLibelleModeleRapport={setLibelleModeleRapport}
                  setRenderModeleEditable={setRenderModeleEditable}
                  typeRapport={typeRapport}
                  setTypeRapport={setTypeRapport}
                />
              )}

              {value === "apartirDUnModeleExistant" && (
                <AddModeleAPartirDUnModeleExistant
                  planRapport={planRapport}
                  setPlanRapport={setPlanRapport}
                  currentModele={currentModele}
                  setCurrentModele={setCurrentModele}
                  setPlanItem={setPlanItem}
                  planItem={planItem}
                  mode={mode}
                  setMode={setMode}
                  typeRapport={typeRapport}
                />
              )}
            </fieldset>

            <Divider style={{ marginBottom: 10, marginTop: 10 }} />

            <fieldset>
              <legend>Elaboration du plan de modèles</legend>
              <AddPlanModele
                planRapport={planRapport}
                setPlanRapport={setPlanRapport}
                currentModele={currentModele}
                setCurrentModele={setCurrentModele}
                setPlanItem={setPlanItem}
                planItem={planItem}
                mode={mode}
                setMode={setMode}
                setDisableSaveButton={setDisableSaveButton}
              />
            </fieldset>
          </Grid>

          {planRapport.length > 0 && (
            <Grid item md={5} xs={12} sm={12}>
              <AfficheContenuPlan
                planRapport={planRapport}
                setPlanRapport={setPlanRapport}
                currentModele={currentModele}
                setMode={setMode}
                setPlanItem={setPlanItem}
                handleSavePlan={handleSavePlan}
                loading={loading}
                setDisableSaveButton={setDisableSaveButton}
                disableSaveButton={disableSaveButton}
              />
            </Grid>
          )}
        </>
      ) : (
        <Grid
          item
          md={12}
          xs={12}
          sm={12}
          style={{ marginTop: endesssousDeLg ? -20 : -100 }}
        >
          <ListeModeleRapport
            setObjetModele={setObjetModele}
            setRenderModeleEditable={setRenderModeleEditable}
            setLibelleModeleRapport={setLibelleModeleRapport}
            libelleModeleRapport={libelleModeleRapport}
            objetModele={objetModele}
            // handleSendOnline={handleSendOnline}
            modelesSelected={modelesSelected}
            setModelesSelected={setModelesSelected}
            // addUserLoading={addUserLoading}
            // setAddUserLoading={setAddUserLoading}
            libelleModeleRapportToEdit={libelleModeleRapportToEdit}
            setLibelleModeleRapportToEdit={setLibelleModeleRapportToEdit}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default Rapport;
